"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryPolicyManager = void 0;
var abr_types_1 = require("./abr-types");
var ts_deepmerge_1 = require("./utils/ts-deepmerge");
var defaultHeuristicConfig = (_a = {
        shouldUseDynamicRetryConfig: false
    },
    _a[abr_types_1.AbrHeuristicBufferState.PANIC] = {
        timeout: 3000,
        connectionTimeout: 3000,
        stallTimeout: 3000,
        maxAttempts: 5,
        baseDelay: 0,
        fuzzFactor: 0,
        backoffFactor: 0,
    },
    _a[abr_types_1.AbrHeuristicBufferState.REBUFFER] = {
        timeout: 6000,
        connectionTimeout: 3000,
        stallTimeout: 3000,
        maxAttempts: 3,
        baseDelay: 0,
        fuzzFactor: 0,
        backoffFactor: 0,
    },
    _a[abr_types_1.AbrHeuristicBufferState.STEADY] = {
        timeout: 90000,
        connectionTimeout: 30000,
        stallTimeout: 15000,
        maxAttempts: 3,
        baseDelay: 100,
        fuzzFactor: 0,
        backoffFactor: 0,
    },
    _a);
var RetryPolicyManager = /** @class */ (function () {
    function RetryPolicyManager(logger, bufferAssessment, cfg) {
        if (cfg === void 0) { cfg = {}; }
        this.bufferAssessment = bufferAssessment;
        this.logger = logger.withContext('Retry Policy Manager');
        this.logger.verbose('Received config: ', cfg);
        this.config = ts_deepmerge_1.merge.withOptions({ allowUndefinedOverrides: false }, defaultHeuristicConfig, cfg);
        this.logger.info('Using config: ', this.config);
    }
    RetryPolicyManager.prototype.registerAbrToPlayer = function (abrToPlayer) {
        var _this = this;
        var handler = function (e) { return _this.handleStabilisedBufferChange(e, abrToPlayer); };
        this.bufferAssessment.addStabilisedBufferChangeListener(handler);
        this.removeEventListener = function () { return _this.bufferAssessment.removeStabilisedBufferChangeListener(handler); };
    };
    RetryPolicyManager.prototype.handleStabilisedBufferChange = function (_a, abrToPlayer) {
        var bufferState = _a.bufferState, isLowBufferExpected = _a.isLowBufferExpected;
        if (!this.config.shouldUseDynamicRetryConfig) {
            return;
        }
        var nextConfig = isLowBufferExpected ? this.config.STEADY : this.config[bufferState];
        abrToPlayer.setRetryPolicy(nextConfig);
    };
    RetryPolicyManager.prototype.destroy = function () {
        var _a;
        (_a = this.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    return RetryPolicyManager;
}());
exports.RetryPolicyManager = RetryPolicyManager;
